import { network, Omit } from 'curvy';
import { TaskRoutes } from '@task-utils/routes';
import { Task, DeepWriteable } from '@task-utils/types';

const { Post, Get, Patch, Delete, Headers } = network;

export namespace UserSettings {
}
